import { IDmLoaiThuBoSungKienThucRequest } from "../../../model/request/category/dmLoaiThuBoSungKienThucRequest";
import {
  IDmLoaiThuBoSungKienThuc,
  IDmLoaiThuBoSungKienThucViewModel,
} from "../../../model/respone/category/IDmLoaiThuBoSungKienThuc";
import { IHeNganhBoSungKienThuc } from "../../reducer-model/category/IDmLoaiThuBoSungKienThucReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiThuBoSungKienThucActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmLoaiThuBoSungKienThucViewModel[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmLoaiThuBoSungKienThuc,
  SAVE_SUCCESS: {} as IDmLoaiThuBoSungKienThucViewModel,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  CHANGE_REQUEST: {} as IDmLoaiThuBoSungKienThucRequest,

  SHOW_EDIT_MODAL: {} as undefined | IDmLoaiThuBoSungKienThucViewModel,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  DELETE_MANY_START: [] as number[],
  DELETE_MANY_SUCCESS: undefined,
  DELETE_MANY_ERROR: "",

  LOAD_THEO_DOT_START: {} as IDmLoaiThuBoSungKienThucRequest,
  LOAD_THEO_DOT_SUCCESS: {} as IDmLoaiThuBoSungKienThuc[],
  LOAD_THEO_DOT_ERRR: "",

  LOAD_HE_NGANH_START: {} as IDmLoaiThuBoSungKienThucRequest,
  LOAD_HE_NGANH_SUCCESS: {} as IHeNganhBoSungKienThuc[],
  LOAD_HE_NGANH_ERRR: "",

  SAVE_MULTIPLE_START: {} as IDmLoaiThuBoSungKienThuc[],
  SAVE_MULTIPLE_SUCCESS: {} as IDmLoaiThuBoSungKienThuc[],
  SAVE_MULTIPLE_ERROR: "",

  CHANGE_VALUE: {} as any,
};
export const eDmLoaiThuBoSungKienThucActionIds = generateActionTypeIds(
  eDmLoaiThuBoSungKienThucActionsObj,
  "LOAI_THU_BO_SUNG_KIEN_THUC",
);
export type IDmLoaiThuBoSungKienThucActionTypes = IGenericActionType<
  typeof eDmLoaiThuBoSungKienThucActionsObj,
  "LOAI_THU_BO_SUNG_KIEN_THUC"
>;
